import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            {item.to && !isLast ? (
              <Link to={item.to} className="transition-colors hover:text-accent-400">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-[10px] text-foreground-400"></i>}
          </span>
        );
      })}
    </nav>
  );
}